var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 23.158,
    viewBox: "0 0 22 23.158",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.83,0a2.492,2.492,0,0,1,2.106,1.2,2.059,2.059,0,0,1,.319,1.227,1.79,1.79,0,0,0,.272,1.019,2.285,2.285,0,0,0,2.982.8,2.446,2.446,0,0,1,3.325.88L21.628,6.5a2.347,2.347,0,0,1-.876,3.277A2.109,2.109,0,0,0,20,12.667a1.791,1.791,0,0,0,.734.741,2.665,2.665,0,0,1,.958.915,2.337,2.337,0,0,1-.024,2.374l-.828,1.389a2.428,2.428,0,0,1-3.349.857,1.887,1.887,0,0,0-1.041-.266,2.21,2.21,0,0,0-2.189,2.107,2.394,2.394,0,0,1-2.449,2.374H10.2a2.4,2.4,0,0,1-2.461-2.374,2.191,2.191,0,0,0-2.177-2.107,1.837,1.837,0,0,0-1.041.266,2.5,2.5,0,0,1-1.254.347,2.471,2.471,0,0,1-2.106-1.2L.34,16.7a2.31,2.31,0,0,1-.024-2.374,2.453,2.453,0,0,1,.947-.915,1.892,1.892,0,0,0,.745-.741A2.124,2.124,0,0,0,1.24,9.773,2.367,2.367,0,0,1,.364,6.5l.793-1.366a2.46,2.46,0,0,1,3.337-.88,2.273,2.273,0,0,0,2.97-.8,1.79,1.79,0,0,0,.272-1.019A2.066,2.066,0,0,1,8.068,1.2,2.541,2.541,0,0,1,10.162,0Zm-.816,8.314a3.272,3.272,0,1,0,0,6.542,3.271,3.271,0,1,0,0-6.542Z",
    fill: "transparent",
    stroke: "#67E1AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.8b2d959dfa60731e5a789a0d2217dd24.svg";
export { ForwardRef as ReactComponent };